import { useCallback } from "react";

/**
 * C5 — Cliente de telemetría fire-and-forget.
 *
 * Cada evento emite POST /v2/telemetry/event con `{ kind, ...payload }`.
 * El endpoint persiste en `audit_events` y escribe en Analytics Engine.
 * Errores se silencian (telemetría nunca debe romper la UX).
 *
 * Uso:
 *
 *   const track = useTelemetry();
 *   track("viewer_section_fold", { doc_id, sec_id });
 *
 * Eventos canónicos (plan v2 §10 + plan-3 §4.D):
 *   - viewer_section_fold       { doc_id, sec_id }
 *   - viewer_overlay_open       { kind, sec_id, cached }
 *   - search_save               { scope, filters_count, has_query }
 *   - search_ask_in_results     { n_results, scope }
 *   - inline_chat_message       { scope, doc_id?, collection_id? }
 *   - annotation_created        { doc_id, kind, color? }
 *   - apuntes_popover_pick      { target_kind, created_new }
 *   - collection_inline_note_add{ collection_slug }
 *   - graph_filter              { scope, depth, min_confidence, types }
 */
export function useTelemetry() {
  return useCallback((kind: string, payload: Record<string, unknown> = {}) => {
    // Best-effort: keepalive ensures the event survives page navigation.
    try {
      void fetch("/v2/telemetry/event", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ kind, ...payload }),
        keepalive: true,
      }).catch(() => undefined);
    } catch {
      /* silent */
    }
  }, []);
}
